<template>
  <ol class="p-content-plan-manual-trend-keywords">
    <ListItemContentManualKeyword
      v-for="keyword in keywordItems"
      :key="keyword.word"
      :keyword="keyword"
      :max="max"
    />
  </ol>
</template>

<script>
import ListItemContentManualKeyword from '@/components/contentPlans/ListItemContentManualKeyword';
import utils from '@/utils';
export default {
  props: {
    tdhWordsItems: {
      type: Array,
      required: true
    },
    scope: {
      type: String, //'h1'|'h2'|'title'|'description'
      required: true
    }
  },
  components: {
    ListItemContentManualKeyword
  },
  computed: {
    keywordItems() {
      const keywords = [];
      this.tdhWordsItems.forEach(item => {
        // rankは圏外だとnull
        // データ取得中: (h1|h2|title|description)がnull
        // データがない: (h1|h2|title|description).wordsがnull
        if (
          item.rank &&
          item.rank >= 1 &&
          item.rank <= 10 &&
          item[this.scope] &&
          item[this.scope].words &&
          item[this.scope].words.length
        ) {
          keywords.push(...item[this.scope].words);
        }
      });
      const groupByKeywords = keywords.reduce((acc, cur) => {
        const found = acc.find(value => value.word === cur.word);
        if (found) {
          found.count += cur.count;
        } else {
          acc.push({
            word: cur.word,
            count: cur.count
          });
        }
        return acc;
      }, []);
      // 1個しか出現しない単語はノイズになりそうなため表示しない
      const filteredGroupByKeywords = groupByKeywords.filter(keyword => {
        return keyword.count > 1;
      });
      return utils.sortNumber(filteredGroupByKeywords, 'desc', 'count');
    },
    max() {
      // 降順に並べているので、1番上のキーワードが1番数が多い
      return this.keywordItems.length ? this.keywordItems[0].count : 0;
    }
  }
};
</script>
